import JshModule from '@core/scripts/helper/jsh-module';

do {
    const {moduleScope, config} = JshModule('teaser/info-i');
    if (!config.entryId) continue;
    const dialog = document.getElementById(`content-platform__info-i__content-${config.entryId}`);
    if (!dialog) continue;
    moduleScope.querySelector('button')?.addEventListener('click', () => {
        dialog.showModal();
    });
    function animateClose(dialog) {
        dialog.classList.add('closing');
        const onTransitionEnd = () => {
            dialog.classList.remove('closing');
            dialog.close();
            dialog.removeEventListener('transitionend', onTransitionEnd);
            dialog.style.transform = '';
            dialog.style.transition = '';
        };
        dialog.addEventListener('transitionend', onTransitionEnd);
    }
    const jsCloseBtns = dialog.querySelectorAll('.close-dialog');
    jsCloseBtns.forEach((button) => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            animateClose(dialog);
        });
    });
    dialog.addEventListener('click', (e) => {
        if (e.target === dialog) {
            animateClose(dialog);
        }
    });
    let dialogTouchStartY = null;
    let dialogDragging = false;
    let dialogCurrentDeltaY = 0;
    const DRAG_CLOSE_THRESHOLD = 20;

    dialog.addEventListener('touchstart', (e) => {
        if (e.touches && e.touches.length === 1) {
            dialogTouchStartY = e.touches[0].clientY;
            dialogDragging = true;
            dialogCurrentDeltaY = 0;
            dialog.style.transition = '';
        }
    });
    dialog.addEventListener('touchmove', (e) => {
        if (!dialogDragging || dialogTouchStartY === null) return;
        const currentY = e.touches[0].clientY;
        const deltaY = currentY - dialogTouchStartY;
        if (deltaY > 0) {
            dialog.style.transform = `translateY(${deltaY}px)`;
            dialogCurrentDeltaY = deltaY;
            if (e.cancelable) {
                e.preventDefault();
            }
        }
    }, { passive: false });
    dialog.addEventListener('touchend', (e) => {
        if (!dialogDragging) return;
        dialogDragging = false;
        if (dialogCurrentDeltaY > DRAG_CLOSE_THRESHOLD) {
            dialog.style.transition = 'transform 0.3s';
            dialog.style.transform = `translateY(100%)`;
            setTimeout(() => {
                animateClose(dialog);
            }, 300);
        } else {
            dialog.style.transition = 'transform 0.2s';
            dialog.style.transform = 'translateY(0)';
            setTimeout(() => {
                dialog.style.transition = '';
                dialog.style.transform = '';
            }, 200);
        }
        dialogTouchStartY = null;
        dialogCurrentDeltaY = 0;
    });
} while (document.querySelector('[jsh-module="teaser/info-i"]') !== null);
